module.exports = __webpack_public_path__ + "static/img/email_img_ezpay.96a9fed8.svg";